import cameraScript from './camera.json';
import { CameraScriptRaw } from '../models/interfaces/Camera';

// eslint-disable-next-line import/prefer-default-export
export const getCameraScript = (): CameraScriptRaw => {
  return cameraScript as CameraScriptRaw;
};
